export enum ShipmentChargeType {

    TRANSPORT = 'TRANSPORT',
    WAITING = 'WAITING',
    LABOR = 'LABOR',
    CUSTOMS_CLEARANCE = 'CUSTOMS_CLEARANCE',
    DAMAGED_GOODS = 'DAMAGED_GOODS',
    MULTIPLE_DROPOFF = 'MULTIPLE_DROPOFF',
    MISCELLANEOUS = 'MISCELLANEOUS'

}
